{
  document.querySelectorAll('button[is="ada-modal-toggler"][data-slide-index]').forEach(button => {
    button.addEventListener('click', () => {
      const index = parseInt(button.getAttribute('data-slide-index'), 10)
      const modal = document.getElementById(button.getAttribute('aria-controls'))
      if (!modal) return

      const slider = modal.querySelector('ada-slider')
      if (!slider) return

      setTimeout(() => {
        slider.goToSlide(index)
      }, 200)
    })
  })
}
